import React, { Fragment } from 'react'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'

import styles from './connection-instructions-style'

const ConnectionInstructionsView = ({ t, room, hasWarning, theme }) => {
  const classes = styles(theme)

  return (
    <Fragment>
      <p className={classes.instructionsTitle}>
        {t('ran_activation_confirmation.instruction_title')}
      </p>
      <ol className={classes.instructions}>
        <li>{t('ran_activation_confirmation.instruction_1', { network: room.ssid })}</li>
        <li>
          {t('ran_activation_confirmation.instruction_2')}
          { hasWarning &&
            <Fragment>
              <br />
              <span dangerouslySetInnerHTML={{ __html: t('ran_activation_confirmation.instruction_2_warning') }} />
          </Fragment>
          }
        </li>
        <li>{t('ran_activation_confirmation.instruction_3')}</li>
      </ol>
    </Fragment>
  )
}

ConnectionInstructionsView.defaultProps = {
  hasWarning: true
}

export default compose(
  withTheme,
  withTranslation(),
)(ConnectionInstructionsView)
